import { BaseAction } from './ActionInterface';
import { ActionTypes } from './ActionTypes';
import { BeerState, Beer } from '../types';

/**
 * Fetch Beers Start Action
 * Indicates that beer data fetching has started
 */
export class FetchBeersStartAction extends BaseAction {
  type = ActionTypes.FETCH_BEERS_START;
  
  execute(state: BeerState): BeerState {
    return {
      ...state,
      loading: true,
      error: null,
    };
  }
}

/**
 * Fetch Beers Success Action
 * Updates the beer list with fetched data
 */
export class FetchBeersSuccessAction extends BaseAction<Beer[]> {
  type = ActionTypes.FETCH_BEERS_SUCCESS;
  
  execute(state: BeerState): BeerState {
    const beers = this.payload || [];
    
    return {
      ...state,
      beers,
      loading: false,
      error: null,
    };
  }
}

/**
 * Fetch Beers Failure Action
 * Handles errors during beer data fetching
 */
export class FetchBeersFailureAction extends BaseAction<Error> {
  type = ActionTypes.FETCH_BEERS_FAILURE;
  
  execute(state: BeerState): BeerState {
    return {
      ...state,
      loading: false,
      error: this.payload || new Error('Unknown error'),
    };
  }
}

/**
 * Update Beer Property Action
 * Updates a specific property of a beer
 */
export class UpdateBeerPropertyAction extends BaseAction<{
  beerId: string;
  property: keyof Beer;
  value: any;
}> {
  type = ActionTypes.UPDATE_BEER_PROPERTY;
  
  execute(state: BeerState): BeerState {
    const { beerId, property, value } = this.payload || { beerId: '', property: 'id', value: null };
    
    if (!beerId || !property) {
      return state;
    }
    
    const updatedBeers = state.beers.map(beer => {
      if (beer.id === beerId) {
        return {
          ...beer,
          [property]: value,
        };
      }
      return beer;
    });
    
    return {
      ...state,
      beers: updatedBeers,
    };
  }
}
